export const IDLESTATUS_AWAY = 'AWAY';
export const IDLESTATUS_INACTIVE = 'INACTIVE';
export const IDLESTATUS_EXPIRED = 'EXPIRED';

export const IDLE_STATUSES = [
  IDLESTATUS_AWAY,
  IDLESTATUS_INACTIVE,
  IDLESTATUS_EXPIRED
];
